import { Dialog } from 'primereact/dialog';
import { Button } from '../../components/ui/Button';
import { toggleDialog } from '../../redux/Slices/Global/globalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useCreateTagMutation, useDetachTag, useGetCompanyTags, useUpdatePlaylistTag } from '../../queries';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputText } from 'primereact/inputtext';
import { Controller, useForm } from 'react-hook-form';
import { useState, useEffect, useRef } from 'react';
import './css/shared.css';

function TagControlDialog({ PlayList }) {
    const { openDialog, companyTags } = useSelector((state) => state.global);
    const dispatch = useDispatch();
    const { control, setValue } = useForm();
    const [showTagOption, setShowTagOption] = useState(false);
    const [tags, setTags] = useState([]);
    const tagContainerRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const updateTags = useUpdatePlaylistTag()
    const activeTagCount = tags.filter(tag => !tag.deleted).length;
    const isTagLimitExceeded = activeTagCount > 3;
    // const hasChanges = tags.some(tag => tag.isNew || (!tag.isNew && !tag.created_at) || tag.deleted);
    const hasChanges = tags.some(tag =>
        tag.isNew || !tag.created_at || tag.deleted
    );

    const disableSave = !hasChanges || isTagLimitExceeded;


    const { isLoading } = useGetCompanyTags(debouncedSearchTerm);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                tagContainerRef.current &&
                !tagContainerRef.current.contains(event.target)
            ) {
                setShowTagOption(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        }
    }, []);


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 400); // 400ms delay

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    useEffect(() => {
        // Initialize tags with a deleted flag
        const initialTags = PlayList?.tags_list?.map(tag => ({ ...tag, deleted: false })) || [];
        setTags(initialTags);
    }, [PlayList]);

    const onClose = () => dispatch(toggleDialog("tagDialog"));

    const saveHandler = async () => {
        const formattedTags = tags.map(tag => ({
            id: tag.isNew ? null : tag.id,
            name: tag.name,
            isNew: !!tag.isNew,
            deleted: !!tag.deleted
        }));

        const payload = {
            tagged_id: PlayList.id,
            tags: formattedTags
        };

        try {
            await updateTags.mutateAsync(payload);
            dispatch(toggleDialog("tagDialog"));
        } catch (err) {
            console.error("Failed to update tags:", err);
        }
    };


    const handleSubmitTag = (tag, isNew) => {
        if (!tag || (typeof tag === "string" && !tag.trim())) return;

        const activeCount = tags.filter(t => !t.deleted).length;
        if (activeCount >= 3) return; // silently ignore or show toast

        let tagName = typeof tag === "string" ? tag : tag.name;

        tagName = tagName.trim().replace(/\s+/g, '-');

        const newTag = {
            id: isNew ? null : tag.id,
            name: tagName,
            deleted: false,
            isNew: isNew
        };

        setTags(prev => [...prev, newTag]);
        setValue("tag", "");
        setShowTagOption(false);
        setDebouncedSearchTerm("");
    };


    const markTagDeleted = (tagId) => {
        setTags(prev =>
            prev.map(tag =>
                tag.id === tagId ? { ...tag, deleted: true } : tag
            )
        );
    };

    const footer = (
        <div className="flex justify-between  items-center gap-2">
            {isTagLimitExceeded && (
                <span className="px-3 text-start text-xs text-red-500">
                    Maximum of 3 tags allowed per playlist
                </span>
            )}
            {!hasChanges && (
                <span className="px-3  text-start py-3 text-xs text-gray-400">
                    No changes to save
                </span>
            )}
            <div className="flex-grow ">

                <Button
                    label="Save"
                    icon="pi pi-check"
                    className="p-button-danger p-button-text"
                    onClick={saveHandler}
                    disabled={disableSave}
                />
            </div>
        </div>
    );



    return (
        <Dialog
            id='dialog_tag_edit'
            visible={openDialog.tagDialog}
            style={{ width: '25vw', height: "45vh" }}
            header={`Edit tags - ${PlayList.name || ""}`}
            modal
            footer={footer}
            onHide={onClose}
        >
            <div className="px-5 pt-5 pb-4">
                <div ref={tagContainerRef} className="relative ">
                    <div className="flex items-center w-full h-[45px] mb-3 bg-gray-200 rounded-2xl px-4 focus-within:ring-2 focus-within:ring-primary transition-all">
                        <i className="pi pi-tag text-gray-500 text-sm mr-3" />
                        <Controller
                            name="tag"
                            control={control}
                            render={({ field }) => (
                                <InputText
                                    {...field}
                                    maxLength={30}
                                    onClick={() => setShowTagOption(true)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();

                                            handleSubmitTag(field.value, true);
                                        }
                                    }}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        setSearchTerm(e.target.value);
                                    }}

                                    // className="flex-1 bg-transparent border-none outline-none ring-0 focus:ring-0 focus:outline-none text-sm"
                                    className="flex-1 bg-transparent border-none outline-none ring-0 focus:ring-0 focus:outline-none focus:border-none shadow-none text-sm !p-0"

                                    placeholder="Add a tag"
                                />
                            )}
                        />
                    </div>

                    {showTagOption &&
                        (companyTags
                            .filter(suggested =>
                                !tags.some(tag => tag.id === suggested.id && !tag.deleted)
                            ).length > 0 ? (
                            <div className="absolute top-full left-0 w-full mt-2 bg-white border rounded-xl shadow-md z-10 p-2 max-h-[200px] overflow-y-auto scroll_div">
                                <div className="flex flex-wrap gap-2">
                                    {companyTags
                                        .filter(suggested =>
                                            !tags.some(tag => tag.id === suggested.id && !tag.deleted)
                                        )

                                        .map((suggestedTag) => (
                                            <span
                                                key={suggestedTag.id}
                                                className="px-2 py-1 bg-gray-100 rounded-full text-sm cursor-pointer hover:bg-gray-200"
                                                onClick={() => handleSubmitTag(suggestedTag, false)}
                                            >
                                                <i className="pi pi-tag text-xs pr-1 text-gray-500" />
                                                {suggestedTag.name}
                                            </span>
                                        ))}
                                </div>
                            </div>
                        )
                            :
                            <small className="absolute top-full left-0 w-full mt-2 bg-white border rounded-xl shadow-md z-10 p-2 h-10 flex justify-center items-center w-100">No options found</small>)

                    }
                </div>

                <div className="pt-4 flex flex-wrap gap-2">
                    {tags.filter(tag => !tag.deleted).map((tag) => (
                        <div
                            key={tag.id}
                            className="flex items-center bg-gray-50 border px-3 py-1 rounded-full shadow-sm cursor-pointer hover:bg-white hover:font-semibold hover:text-gray-600 transition-all"
                        >
                            <span>{tag.name}</span>
                            <i
                                className="pi pi-times text-xs pl-2 hover:text-red-500 transition-all"
                                onClick={() => markTagDeleted(tag.id)}
                            />
                        </div>
                    ))}
                    {tags.filter(tag => !tag.deleted).length === 0 && (
                        <span className="text-sm text-gray-400">No tags assigned</span>
                    )}
                </div>
            </div>

        </Dialog>
    );
}

export default TagControlDialog;
